// Vuetify plugin setup for Medispace UI
// Theme colors can be updated at runtime via useProjectConfig (loads project.json palette)
import 'vuetify/styles';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

const medispaceLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#1976D2', // Darker blue for better contrast
    secondary: '#E65100', // Darker orange for better contrast
    success: '#2E7D32', // Darker green for better contrast
    warning: '#F57C00', // Darker amber for better contrast
    error: '#D32F2F', // Darker red for better contrast
    background: '#FAFAFA', // Slightly darker for better contrast
    surface: '#FFFFFF', // White
    'on-surface': '#212121', // Dark Grey
    'on-primary': '#FFFFFF', // White text on primary
    'on-secondary': '#FFFFFF', // White text on secondary
    'on-success': '#FFFFFF', // White text on success
    'on-warning': '#FFFFFF', // White text on warning
    'on-error': '#FFFFFF', // White text on error
    'focus-ring': '#2196F3', // Focus ring color
  },
};

const medispaceDarkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: '#90CAF9', // Lighter blue for dark theme
    secondary: '#FFB74D', // Lighter orange for dark theme
    success: '#81C784', // Lighter green for dark theme
    warning: '#FFB74D', // Lighter amber for dark theme
    error: '#E57373', // Lighter red for dark theme
    background: '#121212', // Dark background
    surface: '#1E1E1E', // Dark surface
    'on-surface': '#FFFFFF', // White text on dark surface
    'on-primary': '#000000', // Black text on light primary
    'on-secondary': '#000000', // Black text on light secondary
    'on-success': '#000000', // Black text on light success
    'on-warning': '#000000', // Black text on light warning
    'on-error': '#000000', // Black text on light error
    'focus-ring': '#90CAF9', // Focus ring color for dark theme
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'medispaceLightTheme',
    themes: {
      medispaceLightTheme,
      medispaceDarkTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
  defaults: {
    VBtn: {
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class:
        'focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2',
    },
    VTextField: {
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class:
        'focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2',
    },
    VSelect: {
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class:
        'focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2',
    },
    VCheckbox: {
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class:
        'focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2',
    },
    VRadio: {
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class:
        'focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2',
    },
    VCard: {
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class:
        'focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2',
    },
  },
});
